import {Component, OnInit} from '@angular/core';
import {IoReusableElement} from "@app/layout/components/io-reusable-components/element-models";
import {environment} from "@env/environment";

@Component({
  selector: 'app-main-layout',
  standalone: false,
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss'
})
export class MainLayoutComponent implements OnInit {
  ioReusableElement?: IoReusableElement;
  readonly IO_REUSABLE_ELEMENTS_API = environment.reusableComponentFeedUrl;

  ngOnInit(): void {
    fetch(this.IO_REUSABLE_ELEMENTS_API)
      .then(resp => { if (!resp.ok) console.error(resp.status); return resp.json(); })
      .then(reusableFeed => {this.ioReusableElement = reusableFeed});
  }
}
